import React from 'react'
import useStore from '@/store'
import classNames from 'classnames'
import type { Props } from './types'
import Location from '@/components/locations/location'
import styles from './style.module.scss'

const Locations: React.FC<Props> = ({ locations }) => {
  const activeCategoryFilter = useStore((state) => state.activeCategoryFilter)
  const isIdle = useStore((state) => state.isIdle)
  const classes = classNames(styles['locations'], {
    [styles['is-idle']]: isIdle,
  })

  return (
    <div className={classes}>
      {locations?.map((location) => (
        <Location
          key={location.id}
          data={location}
          isActive={Object.values(activeCategoryFilter).some(
            (f) => f === location.attributes.Category.data.attributes.Slug
          )}
          isFiltered={
            Object.values(activeCategoryFilter).some((f) => f !== undefined) &&
            !Object.values(activeCategoryFilter).some(
              (f) => f === location.attributes.Category.data.attributes.Slug
            )
          }
        />
      ))}
    </div>
  )
}

export default React.memo(Locations)
